<template>
  <div>
    <router-view/>
    <MainFooter class="footer"/>
  </div>
</template>

<script>
import MainFooter from '../pages/basic/mainFooter.vue'

export default {
  components: {
    MainFooter
  }
}

</script>

<style scoped>
  .el-main {
    width: 100%;
    height: auto;
    margin-left: 25%;
    padding-top: 250px;
  }
  /* 머리 제목글과 내용 */
  .head {
    width: 50%;
    text-align: left;
    display: inline-block;
  }

  .head >>> p {
    margin: 0;
    font-weight: 300;
  }

  .bigTitle {
    font: normal normal 40px/58px Noto Sans KR-BOLD;
    letter-spacing: -1px;
    color: #5A5B5E;
  }
  .subTitle {
    text-align: left;
    font: normal normal normal 20px/29px Noto Sans KR;
    letter-spacing: 0px;
    color: #5A5B5E;
  }
  .secTitle {
    font: normal normal 300 24px/35px Noto Sans KR;
    letter-spacing: -1.2px;
    color: #5A5B5E;
    margin: 0;
    margin-top: 3%;
  }
  .line1 {
    margin: 0;
    width: 100%;
    height: 3px;
    /* border: 3px solid #333333; */
    border: 0;
    background-color: #333333;
    margin-top: 3%;
  }

  .footer {
    width: 100% !important;
    display: inline-block;
  }

  @media all and (max-width: 768px) {

    .footer {
      width: 100vw;
    }

  }

</style>
